import classNames from "classnames";
import React, { useState } from "react";
import "./styles.mobile.menu.less";

const MobileMenuItem = (props) => {
  const { title, path } = props.data;
  return path ? (
    <a className="item" href={path} target="_blank" rel="noopener noreferrer">
      {title}
    </a>
  ) : (
    <span>{title}</span>
  );
};

export const MobileMenu = (props) => {
  const { name, children } = props.dataSource;
  const [active, setActive] = useState(false);
  return (
    <>
      <div
        className={
          active
            ? classNames("mobile-menu", "mobile-menu-border-none")
            : "mobile-menu"
        }
        onClick={() => {
          setActive((active) => !active);
        }}
      >
        <h4>{name}</h4>
        <span
          className={
            active
              ? "footer-collapse-expaned arrow-footer-outline"
              : "arrow-footer-outline"
          }
        ></span>
      </div>
      <div
        className={
          active
            ? "mobile-menu-item-collapse-expaned mobile-menu-item"
            : "mobile-menu-item"
        }
      >
        {children.map((item, idx) => {
          return (
            <MobileMenuItem
              key={`mobile-menu-item-${item.title}-${idx}`}
              data={item}
            />
          );
        })}
      </div>
    </>
  );
};
